document.addEventListener('DOMContentLoaded', function() {
    // DOM Elements
    const chatButtons = document.querySelectorAll('.open-chat-bubble-button');

    // Helper function to open the chat window
    const openChatBubble = () => {
        if (typeof LC_API !== 'undefined' && LC_API.open_chat_window) {
            LC_API.open_chat_window({ source: 'minimized' });
        }
    };

    // Add click event listener to each chat button
    chatButtons.forEach(button => {
        button.addEventListener('click', openChatBubble);
    });
});